// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCarousel from 'vue-carousel'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Print from 'vue-print-nb'
import VueClipboard from 'vue-clipboard2'
import '../static/fonts/fonts/Kanit/stylesheet.css'
import '../static/fonts/fonts/Athiti/stylesheet.css'
import '../static/fonts/fonts/Poppins/stylesheet.css'
import '../static/fonts/fonts/THSarabun/stylesheet.css'
import '../static/fonts/fonts/CSChatThai/stylesheet.css'
import '../static/fonts/fonts/Maitree/stylesheet.css'
import VueImgOrientationChanger from 'vue-img-orientation-changer'

Vue.use(VueImgOrientationChanger)
// Global instruction 
Vue.use(Print)
const vuetifyOptions = { }
Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueSweetalert2)
Vue.use(VueCarousel)
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(Vuetify, {
 iconfont: 'fa'
})

new Vue({
  el: '#app',
  vuetify: new Vuetify(vuetifyOptions),
  router,
  components: { App },
  template: '<App/>',
  icons: {
    iconfont: 'md'
  }
})



// WEBPACK FOOTER //
// ./src/main.js